import { render } from "./B2bPageOrdersEmit.vue?vue&type=template&id=690e8d8d&scoped=true&lang=pug"
import script from "./B2bPageOrdersEmit.vue?vue&type=script&lang=js"
export * from "./B2bPageOrdersEmit.vue?vue&type=script&lang=js"

import "./B2bPageOrdersEmit.vue?vue&type=style&index=0&id=690e8d8d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690e8d8d"]])

export default __exports__